import React from "react";
import ReactDOM from "react-dom";
import BasicRoute from "./components/Routes/BasicRoute";

ReactDOM.render(<BasicRoute></BasicRoute>, document.getElementById("root"));
